import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-store-image-picker',
  templateUrl: './store-image-picker.page.html',
  styleUrls: ['./store-image-picker.page.scss'],
})
export class StoreImagePickerPage implements OnInit, OnDestroy {
  @Input() allowSelectMultiple = true;
  @Input() selectedImages: number[] = [];

  destroyed$ = new Subject<boolean>();
  loader: HTMLIonLoadingElement;
  isLoading = false;
  translations: any;

  imageList: {
    [key: number]: { src: string; selected: boolean; disabled: boolean };
  } = {};

  totalSelected = 0;

  constructor(
    //private storePageStore: StorePageStore,
    private modalCtrl: ModalController,
    private translate: TranslateService
  ) {
    this.translate
      .get(['STORE', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  ngOnInit(): void {
    this.handleLoading();
    this.handleError();

    /* this.storePageStore.data$.pipe(takeUntil(this.destroyed$)).subscribe(
      (imageList: ImageModel[]) => {
        imageList.forEach((i) => {
          this.imageList[i.id] = {
            src: i.baseUrl + '/' + i.sizes.thumbnail,
            selected: this.selectedImages.includes(i.id),
            disabled: this.selectedImages.includes(i.id),
          };
        });
      }
    );

    this.storePageStore.fetched$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe((fetched) => {
      if (!fetched) {
        this.storePageStore.loadImages();
      }
    }); */
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  handleLoading(): void {
    /* this.storePageStore.loading$.pipe(
      takeUntil(this.destroyed$)
    ).subscribe(async (loading) => (this.isLoading = loading)); */
  }

  handleError(): void {
    /* this.storePageStore.error$.pipe(takeUntil(this.destroyed$)).subscribe(
      async (error) => {
        if (error) {
          const toast = await this.toastController.create({
            message:
              this.translations.ERRORS.STORE.IMAGES[error.after.toLowerCase()],
            duration: 5000,
            color: 'danger',
          });
          toast.present();
        }
      }
    ); */
  }

  toggleSelectImage(id: number): void {
    if (this.imageList[id].disabled) {
      return;
    }

    this.imageList[id].selected = !this.imageList[id].selected;

    if (!this.allowSelectMultiple) {
      this.ok();
    }
  }

  countImages(id: number): void {
    if (this.imageList[id].disabled) {
      return;
    }
    this.totalSelected += this.imageList[id].selected ? 1 : -1;
  }

  ok(): void {
    const selectedImages: { [key: number]: string } = {};
    Object.keys(this.imageList).forEach((key) => {
      if (this.imageList[+key].selected) {
        selectedImages[key] = this.imageList[+key].src;
      }
    });
    this.modalCtrl.dismiss({ selectedImages });
  }

  cancel(): void {
    this.modalCtrl.dismiss();
  }
}
